module.exports = __webpack_public_path__ + "static/media/app-qrcode.e9168396.png";